module.exports = __webpack_public_path__ + "static/details-3-1e1464fe5d6fb495eb998ac821a17327.jpg";